var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostalOffice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 151,
    viewBox: "0 0 152 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 75.5C151.5 101.488 138.367 124.416 118.379 137.986C106.299 146.212 91.7159 151 76 151C60.2841 151 45.7007 146.192 33.6207 137.986C13.633 124.416 0.5 101.488 0.5 75.5C0.5 55.9693 7.93079 38.1871 20.0903 24.7759C24.1037 20.3453 28.6535 16.3914 33.6207 13.0138C34.8326 12.1992 36.0645 11.4045 37.3361 10.6495C48.6412 3.87434 61.8736 0 76 0C81.9009 0 87.623 0.675522 93.1266 1.96697C102.306 4.09289 110.829 7.88776 118.379 13.0337C138.367 26.5839 151.5 49.5121 151.5 75.5Z",
    fill: "#EFDC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.379 119.21H30.6401V124.038H121.379V119.21Z",
    fill: "#33333C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.015 44.9026H33.0044V119.21H119.015V44.9026Z",
    fill: "#C5C5C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2042 119.21H39.8987V103.117C39.8987 98.0703 43.9916 93.9973 49.0382 93.9973H51.0846C56.1312 93.9973 60.2241 98.0902 60.2241 103.117V119.21H60.2042Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.458 119.21H92.1328V103.117C92.1328 98.0703 96.2257 93.9973 101.272 93.9973H103.319C108.365 93.9973 112.458 98.0902 112.458 103.117V119.21Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3315 119.21H66.0061V103.117C66.0061 98.0703 70.099 93.9973 75.1456 93.9973H77.192C82.2386 93.9973 86.3315 98.0902 86.3315 103.117V119.21Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.085 72.3606H39.7202V83.7055H51.085V72.3606Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2244 72.3606H54.8596V83.7055H66.2244V72.3606Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7019 72.3606H70.3372V83.7055H81.7019V72.3606Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8022 72.3606H85.4375V83.7055H96.8022V72.3606Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.28 72.3606H100.915V83.7055H112.28V72.3606Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3849 44.3064C93.3849 53.883 85.5965 61.6516 76 61.6516C66.4036 61.6516 58.635 53.883 58.635 44.3064C58.635 34.7299 66.4234 26.9613 76 26.9613C85.5965 26.9613 93.3849 34.7299 93.3849 44.3064Z",
    fill: "#33333C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5889 38.0875H70.7348C73.6753 38.0875 75.5231 39.6571 75.5231 42.2599C75.5231 44.9819 73.6157 46.5117 70.6951 46.5117H67.6552V50.545H65.5889V38.0875ZM70.6156 39.9154H67.6353V44.7037H70.6354C72.2845 44.7037 73.3773 43.9487 73.3773 42.2798C73.3773 40.6903 72.2845 39.9154 70.6156 39.9154Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5364 38.0875H86.4309V39.9154H82.5168V50.545H80.4505V39.9154H76.5364V38.0875Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.085 72.3606H39.7202V73.5527H51.085V72.3606Z",
    fill: "#5A5A68"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2244 72.3606H54.8596V73.5527H66.2244V72.3606Z",
    fill: "#5A5A68"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6821 72.3606H70.3174V73.5527H81.6821V72.3606Z",
    fill: "#5A5A68"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8022 72.3606H85.4375V73.5527H96.8022V72.3606Z",
    fill: "#5A5A68"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.28 72.3606H100.915V73.5527H112.28V72.3606Z",
    fill: "#5A5A68"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9125 93.0437C44.2102 93.0437 39.561 97.6532 39.561 103.355V106.395C39.561 100.713 44.2102 96.0836 49.9125 96.0836C55.6147 96.0836 60.2639 100.693 60.2639 106.395V103.355C60.2639 97.6532 55.6147 93.0437 49.9125 93.0437Z",
    fill: "#5A5A68"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.027 92.2887C96.325 92.2887 91.6758 96.8982 91.6758 102.6V105.64C91.6758 99.9579 96.325 95.3286 102.027 95.3286C107.729 95.3286 112.379 99.938 112.379 105.64V102.6C112.379 96.8982 107.729 92.2887 102.027 92.2887Z",
    fill: "#5A5A68"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9801 93.0437C70.2779 93.0437 65.6287 97.6532 65.6287 103.355V106.395C65.6287 100.713 70.2779 96.0836 75.9801 96.0836C81.6823 96.0836 86.3316 100.693 86.3316 106.395V103.355C86.3117 97.6532 81.6625 93.0437 75.9801 93.0437Z",
    fill: "#5A5A68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostalOffice);
export default __webpack_public_path__ + "static/media/postal-office.bf2ae02a411d5642bb2d8825924ae08d.svg";
export { ForwardRef as ReactComponent };